'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>Chevron
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_Chevron_variants_cjs_namespaceObject = require("./Chevron.variants.cjs");
const external_withSVGAttributes_cjs_namespaceObject = require("../withSVGAttributes.cjs");
const CHEVRON_LEFT_PATH = 'M12.7071 14.7079C12.3166 15.0985 11.6834 15.0985 11.2929 14.7079L7.05025 10.4653C6.65973 10.0748 6.65973 9.4416 7.05025 9.05108V9.05108C7.44078 8.66055 8.07394 8.66055 8.46447 9.05108L12.7071 13.2937C13.0976 13.6842 13.0976 14.3174 12.7071 14.7079V14.7079Z';
const CHEVRON_RIGHT_PATH = 'M11.293 14.7078C10.9025 14.3173 10.9025 13.6841 11.293 13.2936L15.5357 9.05099C15.9262 8.66046 16.5594 8.66046 16.9499 9.05099V9.05099C17.3404 9.44151 17.3404 10.0747 16.9499 10.4652L12.7073 14.7078C12.3167 15.0984 11.6836 15.0984 11.293 14.7078V14.7078Z';
const CHEVRON_FILL = '#0068EF';
const BaseChevronSVG = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(({ isOpen = false, size = 24, ...props }, ref)=>{
    const { group, chevronLeft, chevronRight } = (0, external_Chevron_variants_cjs_namespaceObject.chevronVariants)({
        ...props,
        isOpen
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("svg", {
        ref: ref,
        height: size,
        width: size,
        ...props,
        "data-testid": "chevron-svg",
        "data-state": isOpen ? 'open' : 'closed',
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("g", {
            className: group(),
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
                    d: CHEVRON_LEFT_PATH,
                    fill: CHEVRON_FILL,
                    className: chevronLeft()
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
                    d: CHEVRON_RIGHT_PATH,
                    fill: CHEVRON_FILL,
                    className: chevronRight()
                })
            ]
        })
    });
});
BaseChevronSVG.displayName = 'BaseChevronSVG';
const Chevron_Chevron = (0, external_withSVGAttributes_cjs_namespaceObject.withSVGAttributes)(BaseChevronSVG);
const Chevron = Chevron_Chevron;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
